/**
 * Trigger a browser download of `data` serialized as pretty-printed JSON.
 * `filenameBase` is sanitized (non-filename chars → `-`) and gets a `.json`
 * extension when missing. Used by the eligibility-check JSON exporter.
 */
export function downloadJson(filenameBase: string, data: unknown): void {
  const safe = filenameBase.replace(/[^a-z0-9._-]+/gi, '-').replace(/^-+|-+$/g, '') || 'eligibility-check'
  const name = safe.toLowerCase().endsWith('.json') ? safe : `${safe}.json`
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
